import React, { Component } from 'react';
import propTypes from 'prop-types';


export default class ModuleContact extends Component {
  // Render
  // ----------------------------------------------------
  render() {

    return (
      <div className="ModuleCard">
        <div className="inner">






        </div>
      </div>
    );
  }
}

ModuleContact.propTypes ={
  changeRecordHandler: propTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/CustomerService/Records/Modules/ModuleContact.js